import { render, staticRenderFns } from "./UserRemoteControl.vue?vue&type=template&id=394c44ae&scoped=true"
import script from "./UserRemoteControl.vue?vue&type=script&lang=js"
export * from "./UserRemoteControl.vue?vue&type=script&lang=js"
import style0 from "./UserRemoteControl.vue?vue&type=style&index=0&id=394c44ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394c44ae",
  null
  
)

export default component.exports